import { makeAutoObservable } from 'mobx'

import { type IField, type ICustomFieldType } from '../api'

export class CustomField {
  id = ''
  apiId: number | null = null
  key = ''
  type: ICustomFieldType = 'text'
  name = ''
  visible = false
  editable = true
  is_used = false

  origin: IField | null = null
  searchFragments: string[] = []

  constructor(item: IField) {
    this.syncOrigin(item)

    makeAutoObservable(this)
  }

  syncOrigin = (item: IField) => {
    this.key = item.key
    this.id = item.key
    this.type = item.type
    this.name = item.name
    this.visible = !!item.visible
    this.editable = 'editable' in item ? item.editable : true

    this.apiId = 'id' in item ? item.id : null
    if ('is_used' in item) {
      this.is_used = item.is_used
    }

    this.origin = item
    this.searchFragments = [item.name]
  }

  get isCustom(): boolean {
    return this.key.startsWith('custom.')
  }

  get template() {
    return `{ ${this.key} }`
  }
}
